import { Button, DialogActions } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const DialogActionsButtons = ({
  produto,
  hideButton,
  handleDelete,
  handleSubmit,
}) => {
  if (hideButton && produto.id === null) return null;
  return (
    <DialogActions>
      {produto.id === null ? (
        <strong
          style={{
            marginRight: "10px",
            color: "red",
            marginBottom: "2%",
          }}
        >
          Para adicionar complementos ou tamanhos ao produto, salve ele e clique
          para edita-lo novamente.
        </strong>
      ) : (
        <Button
          variant="text"
          onClick={() => handleDelete(produto)}
          startIcon={<DeleteIcon />}
        >
          Excluir
        </Button>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={(e) => handleSubmit(e)}
      >
        SALVAR
      </Button>
    </DialogActions>
  );
};

export default DialogActionsButtons;
